import { getCustomErrorsFromProductErrors } from "./dataWrangling";

export { handleProductErrors, handleProductSuccess, handleGraphqlErrors, setDirtyData };

const beforeUnloadEventHandler = e => {
  e.preventDefault();
  return (e.returnValue = "Are you sure you want to exit?");
};

const setDirtyData = (commit, value) => {
  if (value) {
    window.addEventListener("beforeunload", beforeUnloadEventHandler);
  } else {
    window.removeEventListener("beforeunload", beforeUnloadEventHandler);
  }
  commit("setProductDirty", value);
};

const handleGraphqlErrors = ({ commit, rootState }, response) => {
  if (response.errors) {
    commit(
      "flashMessages/setMessages",
      [["error", rootState.i18n.i18n.translations.save_not_possible]],
      { root: true }
    );
    console.log({ errors: response.errors }); // should stay until Airbrake implementation
    return true;
  }

  return false;
};

const handleProductErrors = ({ commit, rootState }, response, type, queryProduct) => {
  if (response.data && response.data[`${type}Product`]?.errors) {
    const errors = getCustomErrorsFromProductErrors(
      response.data && response.data[`${type}Product`]?.errors,
      queryProduct,
      rootState.i18n.i18n.availableLocales
    );
    commit(
      "flashMessages/setMessages",
      [["error", rootState.i18n.i18n.translations.save_not_possible]],
      { root: true }
    );
    commit(
      "validations/setErrors",
      Object.fromEntries(errors.map(error => [error.path[0].split(".").join("_"), error.messages])),
      { root: true }
    );
    return true;
  }
  return false;
};

const handleProductSuccess = ({ commit, rootState }, response, type) => {
  const product = response.data[`${type}Product`]?.product;
  if (product) {
    setProductData(product, commit);
    setVariantData(product, commit);
    setDirtyData(commit, false);
    commit(
      "flashMessages/setMessages",
      [["notice", rootState.i18n.i18n.translations.succesfully_saved]],
      { root: true }
    );
    return true;
  }
};

const setProductData = (product, commit) => {
  if (product.productMaster?.images) {
    commit(
      "setProductImages",
      product.productMaster.images.map(image => {
        return { ...image, persisted: true };
      })
    );
  }
  commit("setProductData", { id: product.id, dirtyImages: false });
};

const setVariantData = (product, commit) => {
  if (product.variants) {
    product.variants.forEach((variant, index) => {
      commit("setVariantImages", {
        images: variant.images.map(image => {
          return { ...image, persisted: true };
        }),
        index,
      });
      commit("setVariantDirty", { index, value: false });
    });
  }
};
